import { track } from './analytics';

document.addEventListener(
  'click',
  (evt) => {
    if (!evt.composedPath) return;

    const path = evt.composedPath();
    const targetEl = path[0];

    const isShadowDom = targetEl.getRootNode && targetEl.getRootNode() !== document;
    if (!isShadowDom) return;

    const anchor = targetEl.closest && targetEl.closest('a');
    if (!anchor || !anchor.href) return;

    let text = (anchor.textContent || '').trim();
    if (!text) {
      text = anchor.getAttribute('aria-label') || anchor.querySelector('img')?.alt || '';
    }

    track('LinkClicked', {
      clickUrl: anchor.href,
      clickText: text || anchor.href
    });
  },
  true // useCapture
);
